// Impure, imported FIRST by the entry: zod's compiled fast path probes
// `new Function` when a schema is built, which the server's CSP forbids (no
// 'unsafe-eval', #287). Configure interpretation before any module builds
// a schema; ES modules evaluate in import order, so this must stay the
// entry's first import.

import { z } from "zod";

z.config({ jitless: true });
